export class CopyLink {
    constructor(el) {
        this.el = el;
        this.links = document.querySelectorAll(".js-copy-link");
        this.input = this.el.querySelector(".js-copy-link-input");
        this.btn = this.el.querySelector(".js-copy-link-btn");
        this.initEvents();
    }

    initEvents() {
        document.addEventListener("click", (e) => {
            let link = null;
            if (e.target.classList.contains("js-copy-link")) {
                link = e.target;
            } else if (e.target.closest(".js-copy-link")) {
                link = e.target.closest(".js-copy-link")
            }
            if (link) {
                this.input.value = link.dataset.link;
            }
        });

        this.btn.addEventListener("click", () => {
            this.input.select();
            document.execCommand("copy");
        });
    }
}

document.querySelectorAll(".js-copy-link-modal").forEach(elem => new CopyLink(elem));
